import React, { useCallback } from 'react';

import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import type { AgentHubBrand } from '~/consts/agentHub';

import { getAgentHubPortalSpoofingLink } from '~/services/AgentHub/AgentService';

import PortalSpoofButton from './PortalSpoofButton';

interface Props {
  user: App.User;
  brand: AgentHubBrand;
  buttonSx?: SxProps<Theme>;
}

function AgentHubPortalSpoofButton({ user, brand, buttonSx }: Props) {
  const generateSpoofingLink = useCallback(
    () => getAgentHubPortalSpoofingLink({ customerId: user.id_member, brand }),
    [user.id_member, brand],
  );

  return (
    <PortalSpoofButton
      buttonLabel="Agent portal spoofing link"
      dialogTitle={
        <>
          Agent portal spoofing link for{' '}
          <Typography component="span" variant="inherit" fontStyle="italic">
            {user.email}
          </Typography>
        </>
      }
      generateSpoofingLink={generateSpoofingLink}
      buttonSx={buttonSx}
    />
  );
}

export default AgentHubPortalSpoofButton;
